/**
 * 主框架：手机上是底部导航（与 iOS 一致），桌面端（≥900px）是左侧导航栏、内容限宽居中。
 * 右下角常驻小星，点击进入语音助手页。
 */
import { Book, Calendar, House, Star, User, type LucideIcon } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router";
import { StarMascot } from "../ui";

interface NavItem {
  to: string;
  title: string;
  icon: LucideIcon;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/", title: "首页", icon: House },
  { to: "/schedule", title: "时间表", icon: Calendar },
  { to: "/learn", title: "学习", icon: Book },
  { to: "/achieve", title: "成就", icon: Star },
  { to: "/me", title: "我的", icon: User },
];

export function AppShell() {
  const { pathname } = useLocation();
  const onAssistant = pathname.startsWith("/assistant");
  return (
    <div className="kp-shell">
      <aside className="kp-sidebar">
        <div className="kp-brand">
          <span className="kp-brand-logo">
            <Star size={20} strokeWidth={2.6} />
          </span>
          <span>kids-planner</span>
        </div>
        <nav>
          {NAV_ITEMS.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={({ isActive }) => `kp-side-link ${isActive ? "is-on" : ""}`}>
              <n.icon size={20} strokeWidth={2.2} />
              <span>{n.title}</span>
            </NavLink>
          ))}
        </nav>
        <NavLink to="/assistant" className={({ isActive }) => `kp-side-assistant ${isActive ? "is-on" : ""}`}>
          <StarMascot size={30} animated={false} />
          <span>语音助手</span>
        </NavLink>
      </aside>

      <main className="kp-main">
        <div className="kp-content">
          <Outlet />
        </div>
      </main>

      {!onAssistant && (
        <NavLink to="/assistant" className="kp-mascot-fab" aria-label="语音助手">
          <StarMascot size={56} />
        </NavLink>
      )}

      <nav className="kp-tabbar">
        {NAV_ITEMS.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.to === "/"} className={({ isActive }) => `kp-tab ${isActive ? "is-on" : ""}`}>
            <n.icon size={22} />
            <span>{n.title}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
